<div class="modal active rnavSettings">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 class="title">RNAV Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngRNAVForm" [formGroup]="form" id="rnavForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>DME/DME Geometry Constraints</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Min DME Facility Range</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.rnav.minDME"
                    formControlName="minDMEFacilityRange"
                    type="number"
                    name="minDME"
                    id="minDME"
                    required
                  />
                  <span span style="width:'5%'">[NM]</span>
                  <span class="error" *ngIf="form.get('minDMEFacilityRange').errors">
                    The Min DME Facility Range value should be defined between 3 and 160.
                   </span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max DME Facility Range</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.rnav.maxDME"
                    formControlName="maxDMEFacilityRange"
                    type="number"
                    name="maxDME"
                    id="maxDME"
                    required
                  />
                  <span span style="width:'5%'">[NM]</span>
                  <span class="error" *ngIf="form.get('maxDMEFacilityRange').errors">
                    The Max DME Facility Range value should be defined between 3 and 160.
                   </span>
                   <span class="error" *ngIf="form.errors">
                    The Doppler Min Value must be smaller than the Doppler Max Value.
                 </span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Elevation Angle</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.rnav.maxElevationAngle"
                    formControlName="maxElevationAngle"
                    type="number"
                    name="maxElevationAngle"
                    id="maxElevationAngle"
                    required
                  />
                  <span style="width:'5%'">[deg]</span>
                  <span class="error" *ngIf="form.get('maxElevationAngle').errors">
                    The Max Evelation Angle Range value should be defined between 0 and 90.
                   </span>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Subtended Angle Range</label>
                  <select
                      name="subtendedAngleRange"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.subtendedAngleRange"
                      formControlName="subtendedAngleRange"
                    >
                      <option value="40-140">40 - 140</option>
                      <option value="30-150">30 - 150</option>
                    </select>
                    <span style="width:'5%'">[deg]</span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>VOR/DME Geometry Constraints</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Conventional Max Range</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.rnav.conventionalMaxRange"
                    formControlName="conventionalMaxRange"
                    type="number"
                    name="conventionalMaxRange"
                    id="ConventionalMaxRange"
                    required
                  />
                  <span span style="width:'5%'">[NM]</span>
                  <span class="error" *ngIf="form.get('conventionalMaxRange').errors">
                    The Conventional Max Range value should be defined between 3 and 160.
                   </span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Doppler Max Range</label>
                  <input
                    maxlength="8"
                    [(ngModel)]="configurationController.currentConfiguration.rnav.dopplerMaxRange"
                    formControlName="dopplerMaxRange"
                    type="number"
                    name="dopplerMaxRange"
                    id="dopplerMaxRange"
                    required
                  />
                  <span span style="width:'5%'">[NM]</span>
                  <span class="error" *ngIf="form.get('dopplerMaxRange').errors">
                    The Doppler Max Range value should be defined between 3 and 160.
                   </span>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Accuracy Parameters</h4>
                <span> </span>
              </div>
                <div class="input-fields">
                  <div>
                    <label for="">Signal In Space Error Budget</label>
                    <input
                      maxlength="8"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.signalInSpaceErrorBudget"
                      formControlName="signalInSpaceErrorBudget"
                      type="number"
                      name="signalInSpaceErrorBudget"
                      id="signalInSpaceErrorBudget"
                      required
                    />
                    <span span style="width:'5%'">[NM]</span>
                    <span class="error" *ngIf="form.get('signalInSpaceErrorBudget').errors">
                      The Conventional Max Range value should be defined between 0 and 5.
                     </span>
                  </div>
                </div>
              </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Performance Calculation Types</h4>
                <span> </span>
              </div>
              <div class="input-fields input-fields--col-2">
                <div>
                  <input
                      id="redundancy"
                      name="redundancy"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.redundancy"
                      formControlName="redundancy"
                      type="checkbox"
                    />
                    <label for="">Redundancy</label>
                </div>

                <div>
                  <input
                      id="subtendedAngle"
                      name="subtendedAngle"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.subtendedAngle"
                      formControlName="subtendedAngle"
                      type="checkbox"
                    />
                    <label for="">Subtended Angle</label>
                </div>

                <div>
                  <input
                      id="nse"
                      name="nse"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.nse"
                      formControlName="nse"
                      type="checkbox"
                    />
                    <label for="">NSE</label>
                </div>

                <div>
                  <input
                      id="availablePairs"
                      name="availablePairs"
                      [(ngModel)]="configurationController.currentConfiguration.rnav.availablePairs"
                      formControlName="availablePairs"
                      type="checkbox"
                    />
                    <label for="">Available Pairs</label>
                </div>

              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
